import React, { ErrorInfo } from 'react';
import { history, routingStore } from './common/stores/routing';
import * as ReactDOM from 'react-dom';
import './account.module.scss';
import { observer } from 'mobx-react';
import { initTime } from './commonv3/utils/time';
import { SheRavenClient } from './commonv2/modules/ravenClient';
import { exposeSurveyFunctions } from './mainv3/apis/surveySubmissions';
import { exposeFbq } from './adminv3/api/facebook';
import { reaction } from 'mobx';
import { scrollToTop } from './mainv2/utils/scroll';
import { experimentState } from './commonv2/states/globalStates';
import { RUNNING_EXPERIMENTS } from './mainv3/experiments';
import { initCsrfConfigV3 } from './commonv3/api/ApiV3';
import { FacebookProvider } from 'react-facebook';
import { GlobalStatesV3 } from './commonv3/states/GlobalStatesV3';
import { V3Routes } from './mainv3/routes';
import { Navigation } from './account/containers/navigation/Navigation';
import { Menu } from './account/containers/navigation/Menu';
import { Redirect, Route, Router, Switch } from 'react-router';
import { AccountRoutes } from './account/routes/AccountRoutes';

declare let FACEBOOK_APP_ID: string;
@observer
class App extends React.Component<any> {
    private unsubscriber: () => any = null;

    async componentDidMount() {
        if (!GlobalStatesV3.currentUser.isSignedIn()) {
            location.href = V3Routes.signIn(location.href).stringify();
        }
        await this.initializeDependencies();
        await experimentState.init(RUNNING_EXPERIMENTS);
    }

    async initializeDependencies() {
        initTime();
        SheRavenClient.init();
        exposeSurveyFunctions();
        exposeFbq();
        this.unsubscriber = reaction(
            () => routingStore.location.pathname,
            () => {
                scrollToTop();
            }
        );
    }

    componentWillUnmount() {
        this.unsubscriber();
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        SheRavenClient.captureException(error, { extra: errorInfo });
    }

    render() {
        return (
            <FacebookProvider appId={FACEBOOK_APP_ID} language="ja_JP">
                <Router history={history}>
                    <div>
                        <Navigation />
                        <div styleName="wrapper">
                            {GlobalStatesV3.viewport.isNonSp && <Menu />}
                            <div styleName="main">
                                <Switch>
                                    <Route
                                        exact
                                        path={AccountRoutes.homeLocation().pathname}
                                        render={() => <div>Home Location</div>}
                                    />
                                    <Route exact path={AccountRoutes.plan().pathname} render={() => <div>Plans</div>} />
                                    <Route
                                        exact
                                        path={AccountRoutes.profile().pathname}
                                        render={() => <div>Profile</div>}
                                    />
                                    <Route
                                        exact
                                        path={AccountRoutes.reservations().pathname}
                                        render={() => <div>Reservations</div>}
                                    />
                                    <Route
                                        exact
                                        path={AccountRoutes.payments().pathname}
                                        render={() => <div>Payments</div>}
                                    />
                                    <Route
                                        exact
                                        path={AccountRoutes.password().pathname}
                                        render={() => <div>Password</div>}
                                    />
                                    <Route
                                        exact
                                        path={AccountRoutes.email().pathname}
                                        render={() => <div>Email</div>}
                                    />
                                    <Redirect to={AccountRoutes.profile()} />
                                </Switch>
                            </div>
                        </div>
                    </div>
                </Router>
            </FacebookProvider>
        );
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initCsrfConfigV3();
    ReactDOM.render(<App />, document.getElementById('content'));
});
